import { Injectable } from '@angular/core';
import { Response, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { WebService } from '../web.service';
import { Theft } from '../../class/theft';

@Injectable()
export class TheftService extends WebService {

    public getTheft (page?: number, per_page?: number, sort?: string, query?: string, filters?: any[]): Observable<Response> {
        let params: URLSearchParams = new URLSearchParams();

        if (page !== null && page !== undefined) {
            params.append('_page', String(page));
        } else {
            params.append('_page', '1');
        }

        if (per_page !== null && per_page !== undefined) {
            params.append('_limit', String(per_page));
        } else {
            params.append('_limit', '10');
        }

        if (sort !== null && sort !== undefined) {
            params.append('_sort', String(sort));
        }

        if (query !== null && query !== undefined && query !== '') {
            params.append('_q', String(query));
        }

        if (filters !== null && filters !== undefined && filters.length > 0) {
            filters.forEach(element => {
                params.append(element.key, String(element.value));
            });
        }

        params.append('_with', String('theft_equipment,theft_has_equipment.inspection_equipment,station,person_who_reports'));

        const options = new RequestOptions({search: params, headers: this.headers});

        return this.http.get( `${this.apiUrl}/thefts?${params}`, options);
    }

    public newTheft(body: Object): Observable<Response> {
        return this.http.post( `${this.apiUrl}/thefts`, JSON.stringify(body) , { headers: this.headers } );
    }

    public updateTheft(id: number, body: Object): Observable<Response> {
        return this.http.patch( `${this.apiUrl}/thefts/${id}`, JSON.stringify(body) , { headers: this.headers } );
    }

    public deleteTheft(id: number): Observable<Response> {
        return this.http.delete( `${this.apiUrl}/thefts/${id}`, { headers: this.headers } );
    }

    public infoTheft(id: number): Observable<Response> {
      let params: URLSearchParams = new URLSearchParams();
      params.append('id', String(id));
      params.append('_with', String('theft_equipment,theft_has_equipment.inspection_equipment,station,person_who_reports'));
      const options = new RequestOptions({search: params, headers: this.headers});
      return this.http.get( `${this.apiUrl}/thefts?${params}`, options);
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/service/theft/theft.service.ts